import { render } from "./Dynamic.vue?vue&type=template&id=69c664a6"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__